import React, { Component } from 'react';
import { Example, Properties, SourceCode } from 'examples';

import Slider from './Slider';

const dummy = [
  {
    position: 0.4,
    iconName: 'mark-in',
    name: 'mark-in'
  },
  {
    position: 0.6,
    iconName: 'mark-out',
    name: 'mark-out'
  },
  {
    position: 0.5,
    name: 'index-1',
    iconName: 'radiobutton-checked',
    connectedTo: 'index-2'
  },
  {
    position: 0.3,
    name: 'index-2',
    iconName: 'radiobutton-checked',
    connectedTo: 'index-1'
  },
  {
    position: 0.5,
    name: 'index-3',
    iconName: 'radiobutton-checked',
    connectedTo: 'index-4'
  },
  {
    position: 0.3,
    name: 'index-4',
    iconName: 'radiobutton-checked',
    connectedTo: 'index-3'
  }
];

export default class SliderExample extends Component {

  state = {
    indexPoints: dummy,
  };

  onChange = e => {
    this.setState(e.target.value);
  };

  onHoverChange = e => {
    // console.log(e.target.value);
  };

  onIndexClick = (e, id) => {
    // console.log(e.target);
  };

  onIndexPointChange = e => {
    // console.log(e.target);
    // const indexPoints = this.state.indexPoints.map((i, idx) => {
    //   const rand = Math.round(Math.random());
    //   if (rand > 0 && idx === e.target.value.arrayIndex) {
    //     return e.target.value.indexPoint;
    //   }
    //   return dummy.find((ip, index) => index === e.target.value.arrayIndex);
    // });
    // this.setState({ indexPoints });
  };

  onSliderChange = e => {
    this.setState({
      value: e.target.value
    });
  };

  render() {
    return (
      <Example {...this.props}>
        <Properties
          defaultProps={Slider.defaultProps}
          propTypes={Slider.propTypes}
          propValues={this.state}
          onChange={this.onChange}
        />
        <Slider
          onChange={this.onSliderChange}
          onHoverChange={this.onHoverChange}
          onIndexPointChange={this.onIndexPointChange}
          {...this.state}
        >
          <div style={{ background: 'black' }}>Long text here</div>
        </Slider>
        <SourceCode querySelector=".core-slider" />
      </Example>
    );
  }

}
